// extracted by css-extract-rspack-plugin
export default {"picker":"Vpr01yAMVlEer6Ud","value":"dcgL_ZU94g8LFict"};